import { Button, Icon } from '@toggle/design-system';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ContinueContextButton } from '../../messages/document-message/continue-context-button/ContinueContextButton';
import { useShouldShowContextButton } from '../../messages/document-message/continue-context-button/utils/utils';
import * as S from './DocumentSourcesHeader.styles';

interface DocumentSourcesHeaderProps {
  onClose: () => void;
  question: string;
  messageIndex: number;
}

export const DocumentSourcesHeader: FC<DocumentSourcesHeaderProps> = ({
  onClose,
  question,
  messageIndex,
}) => {
  const { t } = useTranslation(['intel', 'common']);
  const shouldShowContextButton = useShouldShowContextButton(messageIndex);

  return (
    <S.Header>
      <S.LeftContainer>
        <span>{t('intel:documentSources.searchResult')}</span>
        <S.Divider>|</S.Divider>
        {shouldShowContextButton && (
          <>
            <ContinueContextButton
              flag="CHAT_DOCUMENT_SEARCH_CONTEXT_SEEN_DOC_VIEW"
              messageIndex={messageIndex}
            />
            <Icon iconName="CaretRight" size={12} />
          </>
        )}
        <p>{question}</p>
      </S.LeftContainer>
      <Button
        label={t('common:close')}
        variant="secondary"
        size="small"
        iconName="Close"
        data-testid="close-button"
        onClick={onClose}
      />
    </S.Header>
  );
};
